module.exports = __webpack_public_path__ + "static/img/19.9451824.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/zh/19.png
// module id = YxQf
// module chunks = 0